import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { I18nProvider } from '@/i18n';
import { OverlayProvider } from '@vanguard-atlas/shared';
import { Toaster } from 'sonner';
import { App } from './App';
import '../../shared/src/config/brand.css';
import './index.css';

/**
 * Application entry point
 * 
 * Providers:
 * - QueryClientProvider: React Query for server state management
 * - I18nProvider: Internationalization
 * - BrowserRouter: React Router for navigation
 * - Toaster: Toast notifications (sonner)
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <OverlayProvider>
          <BrowserRouter>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </OverlayProvider>
      </I18nProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
